import store from '@/store'

export default [
  {
    path: '/file-managers',
    name: 'file-manager',
    meta: { requiresAuth: true },
    component: () => import('@/pages/file-manager/index.vue')
  },
  {
    path: '/file-managers/:id',
    name: 'file-manager-folder',
    meta: { requiresAuth: true },
    component: () => import('@/pages/file-manager/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('fileManager/fileBrowser/getFolder', to.params.id)
      next()
    }
  }
]
